import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Divider, Button } from 'antd';
import { connect } from 'react-redux';
import ConfigHeading from '../../configure/components/ConfigHeading';
import { requestPurchaseHistoryAsAdmin } from '../../../../state/ui/purchase/purchaseCreditsUiActions';
import { selectPurchaseHistoryAsAdminRequest } from '../../../../state/ui/purchase/purchaseCreditsUiReducer';
import { selectPurchaseHistory } from '../../../../state/domain/purchases/purchaseHistoryReducer';
import ViaUserSearch from '../../../../components/search/ViaUserSearch';
import { selectUserSummary } from '../../../../state/domain/users/userSummaryReducer';
import '../bynx.css';
import PurchasesTable from '../../purchase/PurchasesTable';
import AddCredit from './AddCredit';


/**
 * Displays the user summary object to help the user remember whop they are talking to
 * @param {object} props.userDetails The user summary object to display
 */
function CurrentDetails({ userDetails }) {
  const [showAddCredit, setShowAddCredit] = useState(false);

  if (!userDetails.userId) return <></>;

  return (
    <div className="credit-enquiry--user-details">
      <div className="user-result--keywords">
        <div>
          <span>
            <b><FormattedMessage id="user" /></b>
          </span>
          :&nbsp;
          <span>
            {userDetails.username}
          </span>
          ,&nbsp;
          <span>{userDetails.displayName}</span>
        </div>
        <div>
          <span>
            <b><FormattedMessage id="company" /></b>
          </span>
          :&nbsp;
          <span>
            {userDetails.companyName}
          </span>
          ,&nbsp;
          <span>{userDetails.address || <FormattedMessage id="noData" />}</span>
        </div>
      </div>
      <div>
        <Button type="primary" onClick={() => setShowAddCredit(true)} icon="plus"><FormattedMessage id="addCredit" /></Button>
      </div>
      <AddCredit username={userDetails.username} visible={showAddCredit} onCancel={() => setShowAddCredit(false)} />
    </div>
  );
}

CurrentDetails.propTypes = {
  userDetails: PropTypes.shape({
    userId: PropTypes.number,
    username: PropTypes.string,
    displayName: PropTypes.string,
    companyName: PropTypes.string,
    address: PropTypes.string,
  }).isRequired,
};

/**
 * A component allowing a bynx admin user to look up a user and retrive the purchase history for their usergroup
 */
function CreditEnqiry({
  isLoading, loadPageData, purchases, getUserDetails,
}) {
  const [userDetails, setUserDetails] = useState();

  const onSelectUser = (userId) => {
    setUserDetails(getUserDetails(userId));
  };

  useEffect(() => {
    if (userDetails) loadPageData(userDetails.userGroupId);
  }, [loadPageData, userDetails]);

  return (
    <div className="via-layout-configure-main">
      <ConfigHeading
        titleId="creditEnquiry"
        descriptionId="creditEnquiryDesc"
      >
        <ViaUserSearch onSelect={onSelectUser} />
        { userDetails && (
          <>
            <Divider />
            <CurrentDetails userDetails={userDetails} />
            <PurchasesTable isLoading={isLoading} purchases={userDetails.userGroupId ? purchases : []} viewInvoice="view-invoice" />
          </>
        )}
      </ConfigHeading>
    </div>
  );
}

// Validate the prop type parameters.
CreditEnqiry.propTypes = {
  isLoading: PropTypes.bool,
  loadPageData: PropTypes.func.isRequired,
  purchases: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      purchaseDateTime: PropTypes.string.isRequired,
      packageTitle: PropTypes.string.isRequired,
      purchaseStatus: PropTypes.string.isRequired,
      currencyCode: PropTypes.string.isRequired,
      mainTokens: PropTypes.number.isRequired,
      extraTokens: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      tokensRemaining: PropTypes.number.isRequired,
      vatCharge: PropTypes.number,
      expiryDate: PropTypes.string,
    }),
  ),
  getUserDetails: PropTypes.func.isRequired,
};

CreditEnqiry.defaultProps = {
  isLoading: false,
  purchases: [],
};

/**
 * A function for connecting redux state to the component props.
 */
const mapStateToProps = (state) => {
  const pageDataRequest = selectPurchaseHistoryAsAdminRequest(state);

  return {
    isLoading: pageDataRequest ? pageDataRequest.isLoading : false,
    purchases: selectPurchaseHistory(state),
    getUserDetails: userId => selectUserSummary(state, userId),
  };
};

/**
 * A function for connecting redux action to the component props.
 */
const mapDispatchToProps = dispatch => ({
  loadPageData: groupId => dispatch(requestPurchaseHistoryAsAdmin(groupId)),
});

/**
 * Connect the redux state to our component.
 */
export default connect(mapStateToProps, mapDispatchToProps)(CreditEnqiry);
